// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import ChevronLeft from "@toolkit/Library/Components/Icons/ChevronLeft";
import ChevronRight from "@toolkit/Library/Components/Icons/ChevronRight";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const itemStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        width: ${pxToRem(32)} !important; /* Override breakpoint widths */
        height: ${pxToRem(32)};
        margin: 0;
        border-radius: ${pxToRem(2)};
        font-size: ${x => x.theme.design.typography.size.base};
        font-weight: ${x => x.theme.design.typography.weight.base}; /* Hercules Custom Code */
        color: ${getColor("text")};
        transition: ${transitionHoverStyles("color", "background-color")};
    `;
};

const pagination: Styleguide["pagination"] = {
    defaultProps: {
        hidePerPageSelect: true,
        hideSinglePage: true,
        navIconsSrc: {
            previousPage: ChevronLeft,
            nextPage: ChevronRight,
        },
        cssOverrides: {
            pagination: css`
                justify-content: center;

                &:not(#important) /* Override breakpoint values */ {
                    ${({ theme }) => css`
                        margin: ${theme.design.typography.spacing.base} 0;

                        ${breakpoint("md")} {
                            margin: ${theme.design.typography.spacing.large} 0;
                        }
                    `}

                    &:first-child {
                        margin-top: 0;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                @media print {
                    display: none;
                }
            `,
            currentButton: css`
                background-color: ${getColor("primary")};
                color: ${getColor("primary.contrast")};
            `,
            ellipsis: css`
                ${itemStyles()}
                font-size: ${pxToRem(22)};
                line-height: ${pxToRem(20)};
                cursor: default;
            `,
            linkList: css`
                ul {
                    display: flex;
                    align-items: center;
                    margin: 0 -${pxToRem(4)};

                    li {
                        margin: 0 ${pxToRem(4)};

                        &:first-child,
                        &:last-child {
                            display: inherit; /* Hercules Custom Code */
                        }
                    }

                    ${breakpoint(360, "down")} {
                        /* Make sure the pagination does not overflow on very small displays */
                        margin: 0 -${pxToRem(2)};

                        li {
                            margin: 0 ${pxToRem(2)};
                        }
                    }
                }
            `,
            perPageSelect: css`
                &:not(#important) /* Override breakpoint values */ {
                    width: auto;
                    margin-right: 1em;
                    margin-left: 1em;
                }
            `,
        },
        buttonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${itemStyles()}
                align-items: center;
                background-color: ${getColor("common.accent")};

                ${IconWrapper} {
                    ${iconScalableStyles(pxToRem(21))}
                    justify-content: center;
                    color: ${getColor("primary")};
                    top: 0;
                }

                &:disabled {
                    background-color: ${getColor("common.accent")};
                    color: ${getColor("text.disabled")};

                    ${IconWrapper} {
                        color: inherit;
                    }
                }

                &:not(:disabled) {
                    &:hover,
                    &:active {
                        background-color: ${getColor("primary")};
                        color: ${getColor("primary.contrast")};

                        ${IconWrapper} {
                            color: inherit;
                        }
                    }
                }
            `,
        },
        selectProps: {
            sizeVariant: "xsmall" as any,
            cssOverrides: null as any,
            labelProps: null as any,
        },
    },
};

export default pagination;
